"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHermes = void 0;
const errors_1 = require("./errors");
const types_1 = require("./types");
__exportStar(require("./types"), exports);
__exportStar(require("./errors"), exports);
function createHermes({ transport, defaultMeta, }) {
    const listeners = {};
    function fetch(path, request) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const response = (yield transport.fetch(path, {
                body: (_a = request === null || request === void 0 ? void 0 : request.body) !== null && _a !== void 0 ? _a : {},
                meta: Object.assign(Object.assign({}, (defaultMeta !== null && defaultMeta !== void 0 ? defaultMeta : {})), ((_b = request === null || request === void 0 ? void 0 : request.meta) !== null && _b !== void 0 ? _b : {})),
            }));
            if (!(response === null || response === void 0 ? void 0 : response.meta.isSuccess)) {
                switch (response === null || response === void 0 ? void 0 : response.meta.code) {
                    case types_1.CodesEnum.BadRequest:
                        throw new errors_1.BadRequestError('Invalid request', response);
                    case types_1.CodesEnum.NotFound:
                        throw new errors_1.NotFoundError('Requested resource was not found', response);
                    case types_1.CodesEnum.Unauthorized:
                        throw new errors_1.UnauthorizedError('Unauthorized to make that request', response);
                    default:
                        throw new errors_1.UnknownError('Unknown error detected', response);
                }
            }
            return response;
        });
    }
    function listen(path, callback) {
        if (listeners[path])
            throw new Error('Listener already exists on that path');
        listeners[path] = callback;
    }
    function handleFetch(path, request) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = {
                body: {},
                meta: {
                    isSuccess: true,
                },
            };
            const handler = listeners[path];
            if (!handler) {
                response.meta = {
                    isSuccess: false,
                    code: types_1.CodesEnum.NotFound,
                };
                return response;
            }
            try {
                yield handler(request, response);
            }
            catch (err) {
                response.meta.isSuccess = false;
                if (err instanceof errors_1.NotFoundError)
                    response.meta.code = types_1.CodesEnum.NotFound;
                else if (err instanceof errors_1.BadRequestError)
                    response.meta.code = types_1.CodesEnum.BadRequest;
                else if (err instanceof errors_1.UnauthorizedError)
                    response.meta.code = types_1.CodesEnum.Unauthorized;
                else
                    throw err;
            }
            return response;
        });
    }
    return {
        fetch,
        listen,
        handleFetch,
    };
}
exports.createHermes = createHermes;
//# sourceMappingURL=index.js.map